import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  icon: css`
    display: flex;
    flex-shrink: 0;
  `,
}
